import { Authorizer } from "@styleguide";
import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const ErrorPage = lazy(() => import("@root/error"));
const HomePage = lazy(() => import("./homePage"));

export const myHomePageRoutes: RouteObject[] = [
  {
    path: "/homePage",
    element: (
      <Authorizer
        requiredPermissions={["homePage.visualize"]}
        Authorized={HomePage}
        redirect="/v2/candidates/dashboard"
      />
    ),
    errorElement: <ErrorPage />,
  },
];
